import { render, staticRenderFns } from "./IndexProduct.vue?vue&type=template&id=73d536f2&scoped=true&"
import script from "./IndexProduct.vue?vue&type=script&lang=js&"
export * from "./IndexProduct.vue?vue&type=script&lang=js&"
import style0 from "./IndexProduct.vue?vue&type=style&index=0&id=73d536f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d536f2",
  null
  
)

export default component.exports